(function (window, document, undefined) {
  'use strict';

  var $ = window.jQuery
    , obituaries;

  function initObituaryMenu_newPage () {

    obituaries = $('.vodl-obituaries.pre-init');
    if ( obituaries.length > 0 ) {

      initObituaryMenu();

      // Initialized - remove event listener if there was one.
      window.removeEventListener( 'newPage', initObituaryMenu_newPage, false );
    }
  }

  function initObituaryMenu () {

    obituaries = $('.vodl-obituaries.pre-init');

    if ( obituaries.length > 0 ) {

      const memories = $('.vodl-obituaries__memories');
      const acknowledgements = $('.vodl-obituaries__acknowledgements');

      memories.on('click', function () {
        obituaries.find('.vodl-obituaries__acknowledgements-list--open')
          .toggleClass('vodl-obituaries__acknowledgements-list--open');

        $('.vodl-obituaries__memories-list')
          .toggleClass('vodl-obituaries__memories-list--open');
      });

      acknowledgements.on('click', function () {
        obituaries.find('.vodl-obituaries__memories-list--open')
          .toggleClass('vodl-obituaries__memories-list--open');

        $('.vodl-obituaries__acknowledgements-list')
          .toggleClass('vodl-obituaries__acknowledgements-list--open');
      });

      obituaries.removeClass('pre-init');
    }

  }

  $(document).ready(function () {

    obituaries = $('.vodl-obituaries.pre-init');
    if ( obituaries.length > 0 ) {

      initObituaryMenu();

    } else {

      // Initialize event listener for lazy obituary widget.
      window.addEventListener('newPage', initObituaryMenu_newPage, false);

    }
  });

})(window, document);
